/**
 * 图片压缩
 *
 * 如果是http外链图片，判断是否是kms233.com的图片，如果是，则进行压缩
 *
 * 如果是本站图片，即以/static开头，则进行压缩
 *
 * 压缩参数为?image_process=resize,w_
 * @param url 图片地址
 */
export function resizeImg(url?: string | null, width?: number | string) {
  if (!url) return ''
  if (url.endsWith('.gif')) {
    return url
  }
  // if url contains mfuns.net, resize it
  if (
    url.startsWith('/static') ||
    url.startsWith('http://localhost:3000/static') ||
    url.startsWith('https://dust-laden.mfuns.net') ||
    url.startsWith('https://cdn.mfuns.net') ||
    url.startsWith('https://oss.mfuns.net') ||
    url.startsWith('https://www.mfuns.net') ||
    url.startsWith('https://resource.mfuns.net')
  ) {
    const src = url.split('?')[0]
    const resize = width ? '?image_process=resize,w_' + width : ''
    return src + resize
  }
  if (url.startsWith('/static')) {
    return 'https://cdn.mfuns.net' + url
  }
  return url
}

export function resizeImgWithConfig(
  url: string | null,
  config: {
    width?: number | string
    height?: number | string
  }
): string {
  if (!url) return ''
  if (url.endsWith('.gif')) {
    return url
  }
  // if url contains mfuns.net, resize it
  if (
    url.startsWith('/static') ||
    url.startsWith('http://localhost:3000/static') ||
    url.startsWith('https://dust-laden.mfuns.net') ||
    url.startsWith('https://cdn.mfuns.net') ||
    url.startsWith('https://oss.mfuns.net') ||
    url.startsWith('https://www.mfuns.net') ||
    url.startsWith('https://resource.mfuns.net')
  ) {
    const src = url.split('?')[0] as string
    if (config.width) {
      const resize = '?image_process=resize,w_' + config.width
      return src + resize
    } else if (config.height) {
      const resize = '?image_process=resize,h_' + config.height
      return src + resize
    }
    return src
  }
  if (url.startsWith('/static')) {
    return 'https://cdn.mfuns.net' + url
  }
  return url
}
